import React from 'react'
import {
    ThanksContainer, ThanksText
} from './Style';
const ThankYou = () => {
    return (
        <ThanksContainer>
            <ThanksText>Thank You For Updating Your Doctor Profile</ThanksText>
        </ThanksContainer>
    )
}

export default ThankYou
